import { render, staticRenderFns } from "./p2p.vue?vue&type=template&id=3cd14c68&scoped=true&"
var script = {}
import style0 from "./p2p.vue?vue&type=style&index=0&id=3cd14c68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd14c68",
  null
  
)

export default component.exports